// Generated by demidtheme_mfe (notifications had no Atlas RU on this revision).
import ru from './ru.json';

export default {
  'ru': ru,
};
